import { IObjectTranslatable } from ".";
import { IPositionCorrectItemBean, ITypeDefinable, BeanTypes } from "../beans/items";
import { IItem, PositionCorrectItem } from "../../../../domain/document/items";

import {
  Point,
  Size,
  Rectangle,
} from "../../../../domain/drawing";

export class PositionCorrectItemTranslator implements IObjectTranslatable {
  toItem(item: ITypeDefinable, formatId: number, groupId: number, documentId: number, executionMode: string): IItem {
    const bean = item as IPositionCorrectItemBean;
    const result = new PositionCorrectItem();
    result.privateId = (bean as any).privateId; // フロントエンド独自パラメータ.
    result.uniqueKey = bean.uniqueKey;
    result.id = bean.id;
    result.sectionObjectUid = bean.sectionObjectUid;
    result.isEditable = true; // TODO:特に問題なければプロパティを削除する
    result.isAdditional = !!bean.isAdditional;
    result.isDeleted = !!bean.isDeleted;
    result.isVisible = false; // ヘッダがあるフォーマットの場合表示がずれてしまう(ヘッダ位置基準の位置情報を持っている)ため全体的に表示しないようにする
    result.typeDetail = bean.typeDetail;
    result.viewTitle = bean.viewTitle;
    result.printBehavior.shouldPrint = !!bean.printVisible;
    result.printBehavior.shouldPreview = !!bean.previewVisible;
    result.geometry.rectangle = new Rectangle(new Point(bean.x, bean.y), new Size(bean.width, bean.height));
    return result;
  }

  toBean(item: IItem): IPositionCorrectItemBean {
    const target = item as PositionCorrectItem;
    return {
      type: BeanTypes.PosCorrect,
      uniqueKey: target.uniqueKey,
      id: target.id,
      sectionObjectUid: target.sectionObjectUid,
      isVisible: true,  // 返却不要だがI/Fに入っているのでコンパイルエラー回避で入れている
      printVisible: target.printBehavior.shouldPrint,
      previewVisible: target.printBehavior.shouldPreview,
      x: target.geometry.rectangle.x,
      y: target.geometry.rectangle.y,
      width: target.geometry.rectangle.width,
      height: target.geometry.rectangle.height,
      isAdditional: target.isAdditional,
      isDeleted: target.isDeleted,
      typeDetail: target.typeDetail,
      viewTitle: target.viewTitle,
    };
  }
}
